{
  "title": "無法預約活動接駁車",
  "description": "預約接駁座位失敗或按鈕無法使用時的排查方式。",
  "headings": [
    "症狀",
    "最常見原因",
    "排查方式",
    "正常結果",
    "仍無法解決"
  ],
  "symptom": "按下「預約座位」後出現錯誤、按鈕呈灰色，或免登入預約沒有收到確認信。",
  "causes": [
    "Email 尚未驗證（登入預約需要已驗證的 Email）",
    "同一天同一方向已有預約或候補，其他班次因此被鎖定",
    "已超過發車前 12 小時的預約截止，或班次尚未開放",
    "尚未填寫乘車聯絡資料（第一次預約必填）",
    "免登入預約的確認連結已超過 30 分鐘或已使用過",
    "此 Email 屬於需以一般方式登入的帳號（例如平台管理員）",
    "同一 Email 在 10 分鐘內請求超過 3 次，之後不會再寄信"
  ],
  "diagnosis": [
    {
      "title": "Step 1",
      "description": "看班次卡下方的訊息。「你在該日期與方向已有預約或候補」代表要先取消原本的預約才能改選其他班次；「此班次已截止預約」代表已逾發車前 12 小時。"
    },
    {
      "title": "Step 2",
      "description": "若提示請先驗證 Email，請到信箱開啟驗證信完成驗證，再回到預約頁重試。"
    },
    {
      "title": "Step 3",
      "description": "若提示請先填寫乘車聯絡資料，請填寫真實姓名並勾選確認，儲存後會自動完成預約。"
    },
    {
      "title": "Step 4",
      "description": "免登入預約沒收到信：先查垃圾郵件，確認 Email 拼字；確認連結只在 30 分鐘內有效且只能開啟一次，過期請回預約頁重新申請。同一 Email 短時間內請求太多次時系統不再寄信且回應與成功相同，請等 10 分鐘後再試。"
    },
    {
      "title": "Step 5",
      "description": "畫面顯示此 Email 需以一般方式登入時，請改用登入頁登入後再預約。"
    }
  ],
  "resolution": "修正上述問題後即可預約；若是額滿，請加入候補，有人取消時會自動遞補並寄 Email 通知。",
  "stillStuck": [
    "活動名稱與班次代碼",
    "預約的日期與方向",
    "發生時間",
    "畫面上的錯誤訊息",
    "Screenshot"
  ],
  "doNotProvide": [
    "密碼",
    "驗證碼",
    "乘車 QR 或憑證",
    "Token"
  ],
  "nextSteps": "確認後仍無法解決，請到活動頁「客服與協助」選擇「交通接駁」送出案件。"
}
